import Vue from 'vue'
import VueRouter from 'vue-router'
import Desktop from './components/desktop'
import Mobile from './components/mobile'

import Leaderboard from './components/leaderboard'
import Following from './components/following'
import AthleteDetailed from './components/athlete/athletedetailed'
import Checkpoint from './components/checkpoint/checkpoint'
import Menu from './components/menu'
import Categories from './components/categories'
import Header from './components/header'
import GMap from './components/gmap'
import Leaflet from './components/leaflet'
import Profile from './components/profile/profile'
import Sportraxs from './components/sportraxs'
import Routing from './components/routing'
import Search from './components/search'
import Races from './components/races'
import Sponsors from './components/sponsors'
import NotFound404 from './components/404'
import Details from './components/details'
import Sidebar from './components/sidebar'
import Sidebarm from './components/sidebarm'
import Social from './components/social/social'
import athleteOverlay from "./components/athleteOverlay";

Vue.use(VueRouter)


const routes = [
  { path: '/:domain/:raceId',
    redirect: '/:domain/:raceId/leaderboard',
    components: {
      default: Desktop,
      header: Header,
      map: Leaflet,
      profile: Profile,
      sponsors: Sponsors,
      sidebar: Sidebar,
    },
    children: [
      { path: 'leaderboard',
        name: 'leaderboard',
        meta: {analytics: 'Leaderboard'},
        components: {
          leaderboard: Leaderboard,
          routing: Routing,
          search: Search,
          races: Races,
          sportraxs: Sportraxs,
          categories: Categories
        }
      },
      { path: 'social',
        name: 'social',
        meta: {analytics: 'Social'},
        components: {
          social: Social,
          routing: Routing
        }
      },
      { path: 'details',
        name: 'details',
        meta: {analytics: 'Details'},
        components: {
          details: Details,
          routing: Routing,
          search: Search,
          sportraxs: Sportraxs,
          categories: Categories
        }
      },
      { path: 'following',
        name: 'following',
        meta: {analytics: 'Following'},
        components: {
          following: Following,
          sportraxs: Sportraxs,
          routing: Routing
        }
      },
      { path: 'checkpoint/:id',
        name: 'checkpoint',
        meta: {analytics: 'Checkpoint'},
        components: {
          checkpoint: Checkpoint,
          sportraxs: Sportraxs,
          routing: Routing
        }
      },
      { path: 'athlete/:id',
        name: 'athlete',
        meta: {analytics: 'Athlete'},
        components: {
          athletedetailed: AthleteDetailed,
          sportraxs: Sportraxs,
          routing: Routing
        }
      }
    ]
  },
  { path: '/m/:domain/:raceId',
    redirect: '/m/:domain/:raceId/map',
    components: {
      default: Mobile,
      header: Header,
      sponsors: Sponsors,
      sidebarm: Sidebarm,
      routing: Routing
    },
    children: [
      { path: 'leaderboard',
        name: 'mleaderboard',
        meta: {analytics: 'Leaderboard'},
        components: {
          leaderboard: Leaderboard,
          search: Search,
          race: Races,
          categories: Categories
        }
      },
      { path: 'following',
        name: 'mfollowing',
        meta: {analytics: 'Following'},
        components: {
          following: Following
        }
      },
      { path: 'checkpoint/:id',
        name: 'mcheckpoint',
        meta: {analytics: 'Checkpoint'},
        components: {
          checkpoint: Checkpoint
        }
      },
      { path: 'menu',
        name: 'menu',
        meta: {analytics: 'Menu'},
        components: {
          menu: Menu
        }
      },
      { path: 'map',
        name: 'map',
        meta: {analytics: 'Map'},
        components: {
          map: Leaflet,
          profile: Profile
        },
        children: [ {
          name: 'mapathlete',
          path: 'athlete/:id',
          component: athleteOverlay
        }
        ]
      },
      { path: 'athlete/:id',
        name: 'mathlete',
        meta: {analytics: 'Athlete'},
        components: {
          athletedetailed: AthleteDetailed
        }
      },
      { path: 'social',
        name: 'msocial',
        meta: {analytics: 'Social'},
        components: {
          social: Social
        }
      },
    ]
  },
  {
    path: '*',
    components: {
      notfound404: NotFound404
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})



export default router



// WEBPACK FOOTER //
// ./src/router.js